import ApiClient from '@/api/ApiClient';

export default class ApiAuth {

  public static signinWithGoogle() {
    return ApiClient.post('/oauth/token/confirmation', {});
  }

}
